export enum FORM_FIELDS {
    EMAIL = 'email',
    PASSWORD = 'password',
}

export type FormFieldsType = {
    [FORM_FIELDS.EMAIL]: string;
    [FORM_FIELDS.PASSWORD]: string;
}